module.exports = __webpack_public_path__ + "static/media/Coat-of-arms-of-Nigeria-01.da57b04d.png";